import { ajax } from '@/util/ajax'

const BASE_URL = '/gateway/platform-oamapi/employee/'

const EmployeeApi = {
  searchEmployeeInfo (input, success, failure) {
    return ajax.get(
      BASE_URL + '/search',
      input,
      success,
      failure
    )
  }
}

export { EmployeeApi }
